<template>
  <PageTitle hideMarginLeft>Заявки поставщикам</PageTitle>
  <div class="filters">
    <div class="filters__item">
      <CustomInput :value="this.searchTerm" :isSearch="true" placeholder="Поиск заявки по ID" class="project-id-search"
        v-debounce:300="this.onSearchChange" />
    </div>
  </div>

  <NotFoundText v-if="!this.requestsData.length" />
  <CustomTable v-else :rowsData="this.requestsData" :columns="getProviderRequestDetailColumns" :custom-body="true"
    :striped="true" :hoverless="true" :bordered="true" row-key="request_id" class="main_nested_table">
    <template #customBody="props">
      <q-tr :props="props" :class="{ 'row-expanded': this.expandedRows[props.row.provider_request_id] }">
        <CustomTableCell align="left" vertical-align="center" width="180px">
          <div class="application">
            <div class="application__item">
              <span class="application__label">ID заявки:</span> {{ props.row.provider_request_id || '-' }}
            </div>
            <div class="application__item">
              <span class="application__label">ID проекта:</span>
              <Clickable router-link
                :href="`/projects-entry?tab=projects_overview&resident_id=${props.row.resident_id}&project_type_id=${props.row.project_type_id}`">
                {{ props.row.project_id || '-' }}
              </Clickable>
            </div>
            <div class="application__item" v-if="props.row.provider_request_initiator_type_name">
              <span class="application__label">Тип:</span>
              <span
                class="tw-text-[#004377] tw-bg-[#A9D3F2] tw-px-1 tw-py-1 tw-rounded-md tw-inline-block tw-text-[10px]">
                {{ props.row.provider_request_initiator_type_name }}
              </span>
            </div>
          </div>
        </CustomTableCell>
        <CustomTableCell align="center" vertical-align="center" style="font-size: 12px; max-width: 150px">
          {{ props.row.provider_name }}
        </CustomTableCell>
        <CustomTableCell align="center" vertical-align="center" style="font-size: 12px; max-width: 150px">
          {{ props.row.contractor_name }}
        </CustomTableCell>
        <CustomTableCell align="left" vertical-align="center">
          <div class="address">
            <div class="address__item">
              <span class="address__label">Город:</span>
              <span class="address__value">{{ props.row.city_name || '-' }}</span>
            </div>
            <div class="address__item">
              <b>ЖК:</b> {{ props.row.resident_name || '-' }}
            </div>
            <div class="address__item">
              <b>Адрес ЖК:</b> {{ props.row.resident_address || '-' }}
            </div>
          </div>
        </CustomTableCell>
        <CustomTableCell align="left" vertical-align="center">
          <div
            class="flex align-center justify-center tw-p-1 tw-bg-[#DEF1FF] tw-rounded-[4px] tw-mb-2 tw-text-[#373D48] tw-cursor-pointer tw-text-[10px]"
            v-for="invoice in props.row.invoices" :key="invoice.provider_request_invoice_item_id"
            @click="openInvoiceModal(invoice)">
            <div class="tw-flex tw-gap-2">
              <span><b>№</b> {{
                invoice.invoice_num || "Нет номера" }}</span>
            </div>
            <q-tooltip>Посмотреть</q-tooltip>
          </div>
        </CustomTableCell>
        <CustomTableCell align="left" vertical-align="center">
          <div
            class="flex align-center justify-center tw-p-1 tw-bg-[#DEF1FF] tw-rounded-[4px] tw-mb-2 tw-text-[#373D48] tw-cursor-pointer tw-text-[10px]"
            v-for="realize in props.row.realization" :key="realize.realization_id"
            @click="openRealizationModal(realize)">
            <div class="tw-flex tw-gap-2">
              <span v-if="realize.realize_num"><b>№</b> {{
                realize.realize_num || "Нет номера" }}</span>
            </div>
            <q-tooltip>Посмотреть</q-tooltip>
          </div>
        </CustomTableCell>
        <CustomTableCell vertical-align="center" style="width: 150px">
          <div class="address">
            <div class="count__item">
              Кол-во - {{ props.row.status_total_cnt || '-' }}
            </div>
            <div class="count__item" v-for="status in props.row.statuses" :key="status.status">
              {{ status.status }} - {{ status.cnt }}
            </div>
          </div>
        </CustomTableCell>
        <CustomTableCell align="center" vertical-align="center" width="80px">
          <q-btn dense flat round icon="keyboard_arrow_down"
            :class="['expand-btn', { 'expand-btn--open': this.expandedRows[props.row.provider_request_id] }]"
            @click="() => this.toggleExpand(props.row.provider_request_id)" />
        </CustomTableCell>
      </q-tr>

      <q-tr v-if="this.expandedRows[props.row.provider_request_id]" :props="props" class="details-row">
        <q-td :colspan="getProviderRequestDetailColumns.length">
          <span class="tw-font-bold tw-text-[#373D48] tw-mb-4">Материалы заявки №{{
            props.row.provider_request_id
          }}</span>
          <CustomTable :rowsData="this.detailMap[props.row.provider_request_id] || []"
            :columns="tradingHouseRequestColumns" :custom-body="true" :hoverless="true" :bordered="true"
            :allWidth="true" :sticky-header="false" separator="cell" row-key="material_id" :small="true"
            :loading="this.detailLoading[props.row.provider_request_id]" class="nested-table">
            <template #customBody="materialProps">
              <q-tr :props="materialProps">
                <CustomTableCell align="center" vertical-align="center" width="80px">
                  {{ materialProps.row.material_id || '-' }}
                </CustomTableCell>
                <CustomTableCell align="left" vertical-align="center">
                  <div style="padding-left: 10px;">
                    {{ materialProps.row.material_name || '-' }}
                  </div>
                </CustomTableCell>
                <CustomTableCell align="center" vertical-align="center" width="120px">
                  {{ materialProps.row.date_shipping || '-' }}
                </CustomTableCell>
                <CustomTableCell align="center" vertical-align="center" width="80px">
                  {{ materialProps.row.material_cnt || '-' }}
                </CustomTableCell>
                <CustomTableCell align="center" vertical-align="center" width="80px">
                  {{ materialProps.row.sell_unit_name || '-' }}
                </CustomTableCell>
                <CustomTableCell align="center" vertical-align="center" width="80px">
                  {{ this.formatCurrency(materialProps.row.price) }}
                </CustomTableCell>
                <CustomTableCell align="center" vertical-align="center" width="120px">
                  {{ this.formatCurrency(materialProps.row.material_sum) }}
                </CustomTableCell>
                <CustomTableCell align="center" vertical-align="center" width="100px">
                  {{ materialProps.row.shipped_cnt }}
                </CustomTableCell>
              </q-tr>
            </template>
          </CustomTable>
        </q-td>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import PageTitle from "@/components/common/PageTitle.vue";
import CustomInput from "@/components/form/CustomInput";
import NotFoundText from "@/components/common/NotFoundText.vue";
import Clickable from "@/components/common/Clickable";
import { numberWithCommas } from "@/services/index";
import { tradingHouseRequestColumns, getProviderRequests, getProviderRequestDetailColumns, getProviderRequestDetail } from "@/views/TradingHouse/services";
import { useAppStore } from "@/services/store/app";
import { MODAL_NAMES } from "@/constants";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "TradingHouse",
  components: { CustomTableCell, CustomTable, PageTitle, CustomInput, NotFoundText, Clickable },
  data() {
    return {
      tradingHouseRequestColumns,
      getProviderRequestDetailColumns,
      searchTerm: "",
      requests: [],
      isFetching: false,
      expandedRows: {},
      requestsData: [],
      detailMap: {},
      detailLoading: {},
    };
  },
  methods: {
    numberWithCommas,
    onSearchChange(value) {
      this.searchTerm = value || "";
      this.updateUrlParams();
      this.getData();
    },
    updateUrlParams() {
      const query = { ...this.route.query };
      if (this.searchTerm) {
        query.provider_request_id = this.searchTerm;
      } else {
        delete query.provider_request_id;
      }
      this.router.replace({ query });
    },
    openLink(link) {
      if (!link) return;
      window.open(link, "_blank");
    },
    formatCurrency(value) {
      if (value === undefined || value === null || value === "") return "-";
      return numberWithCommas(value);
    },
    async getData() {
      this.isFetching = true;
      const params = {};
      if (this.searchTerm) {
        params.provider_request_id = this.searchTerm;
      }
      const res = await getProviderRequests(params);
      this.isFetching = false;
      if (!res) return;
      this.requestsData = res;
    },
    async getProviderRequestDetail(provider_request_id) {
      this.detailLoading = { ...this.detailLoading, [provider_request_id]: true };
      const res = await getProviderRequestDetail({ provider_request_id });
      this.detailLoading = { ...this.detailLoading, [provider_request_id]: false };
      if (!res) return;
      this.detailMap = { ...this.detailMap, [provider_request_id]: res };
    },
    openInvoiceModal(invoice) {
      if (!invoice) return;
      const invoiceNum = invoice.invoice_num || 'Нет номера';
      const invoiceDate = invoice.invoice_date || 'Нет даты';
      this.showModal(MODAL_NAMES.ProviderInvoiceInfo, {
        title: `Накладная №${invoiceNum} от ${invoiceDate}`,
        invoice,
      });
    },
    openRealizationModal(realization) {
      if (!realization) return;
      const realizeNum = realization.realize_num || 'Нет номера';
      const realizeDate = realization.realize_date || 'Нет даты';
      this.showModal(MODAL_NAMES.ProviderRealizationInfo, {
        title: `Реализация №${realizeNum} от ${realizeDate}`,
        realization,
      });
    },
    toggleExpand(provider_request_id) {
      const willOpen = !this.expandedRows[provider_request_id];
      this.expandedRows = { ...this.expandedRows, [provider_request_id]: willOpen };
      if (willOpen && !this.detailMap[provider_request_id]) {
        this.getProviderRequestDetail(provider_request_id);
      }
    },
  },
  computed: {},
  watch: {
    "$route.query.provider_request_id"(newValue) {
      if (newValue !== this.searchTerm) {
        this.searchTerm = newValue || "";
        this.getData();
      }
    },
  },
  mounted() {
    const providerRequestId = this.route.query.provider_request_id;
    if (providerRequestId) {
      this.searchTerm = providerRequestId;
    }
    this.getData();
  },
  setup() {
    const { showModal } = useAppStore();
    const route = useRoute();
    const router = useRouter();
    return { showModal, route, router };
  },
}
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.filters__item {
  width: 250px;
}

.project-id-search {
  width: 100%;
}

.requests-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.request-accordion {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;

  :deep(.q-expansion-item__container) {
    padding: 0;
  }

  :deep(.q-item) {
    padding: 14px 18px;
    min-height: 56px;
  }
}

.request-accordion__header {
  background: #fff;
}

.request-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.request-header__title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #111827;
  font-weight: 600;
}

.request-header__label {
  color: #373D48;
  font-weight: 400;
}

.request-header__value {
  color: #4b5563;
  font-weight: 600;
}

.request-header__badge {
  background: #e9f3ff;
  color: #1d4ed8;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 9999px;
}

.request-body {
  padding: 16px;
}

.details-row {
  background: #f9fafb;
}

.row-expanded {
  background: #D8FFD8;

  &:hover {
    background: #D8FFD8 !important;
  }
}

.status-badge {
  background: #e9f3ff;
  color: #1d4ed8;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 9999px;
}

.expand-btn {
  transition: transform 0.2s ease;

  &--open {
    transform: rotate(180deg);
  }
}

.address {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #111827;
  font-size: 12px;
}

.address__item--multiline {
  flex-direction: column;
  align-items: flex-start;
}

.address__label {
  color: #373D48;
  font-weight: 700;
}

.address__value {
  color: #111827;
  display: inline-block;
}

.count__item {
  font-size: 12px;
  font-weight: 700;
}

.count__value {
  font-size: 12px;
  font-weight: 700;
  padding: 2px 12px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main_nested_table {
  :deep(.custom-table) {
    --tbl-radius: 10px !important;
    border-radius: 10px !important;
  }
}

.nested-table {
  :deep(.custom-table) {
    --tbl-radius: 8px !important;
    border-radius: 8px !important;
  }

  :deep(.q-table tbody td) {
    font-size: 12px;
  }
}

.application {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
}

.application__item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.application__label {
  color: #373D48;
  font-weight: 700;
}

.application__value {
  color: #111827;
  display: inline-block;
}
</style>